import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchSchwankungenApi } from './aktienApi';

/**
 * Redux-Slice fuer den News-Bereich "Schwankungen": Aktien mit auffaelliger
 * Tagesbewegung (Start-Ende, Start-Hoch oder Start-Tief > 10 %) der letzten Woche.
 */
export const fetchSchwankungen = createAsyncThunk(
  'schwankungen/fetchAlle',
  async () => {
    return (await fetchSchwankungenApi()) ?? [];
  }
);

const initialState = {
  liste: [],
  status: 'idle', // idle | loading | succeeded | failed
  error: null,
};

const schwankungenSlice = createSlice({
  name: 'schwankungen',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSchwankungen.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchSchwankungen.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.liste = action.payload;
      })
      .addCase(fetchSchwankungen.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const selectSchwankungen = (state) => state.schwankungen.liste;
export const selectSchwankungenStatus = (state) => state.schwankungen.status;

export default schwankungenSlice.reducer;
